module.exports = __webpack_public_path__ + "static/media/add-document.8b133007.svg";